import styled, { css } from 'styled-components';
import {
    Adornment,
    AdornedInput,
    IconCloseOutline,
    Input,
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledSpacer = styled.div`
    width: ${spaceMixin('md')};
    height: ${spaceMixin('md')};
`;

export const StyledAdornedInput = styled(AdornedInput)`
    > .adornmentWrapper:focus {
        border: 1px solid ${token('colors.gray300')};
        border-left: none;
        outline: 5px auto -webkit-focus-ring-color;
    }

    > input:disabled:hover ~ .adornmentWrapper {
        border: 1px solid ${token('colors.gray300')};
        border-left: none;
        cursor: pointer;
    }

    /* 0 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.xs}px)`, css`
        width: 100%;
    `)};
`;

export const StyledIconCloseButton = styled(IconCloseOutline)`
    fill: ${token('colors.linkActive')};
`;

export const StyledInput = styled(Input)`
    color: ${token('colors.black')};
    opacity: 1;
`;

export const StyledAddAmenityInput = styled(Input)`
    /* 0 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.xs}px)`, css`
        width: 100%;
    `)};

    /* 480 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.md - 1}px)`, css`
        width: 75%;
    `)};
`;

export const StyledAdornment = styled(Adornment)`
    background-color: ${props => (props.notEditing ? token('colors.gray100') : '')};
`;
